import { render, staticRenderFns } from "./FollowUpCaseCard.vue?vue&type=template&id=0acccca1&scoped=true"
import script from "./FollowUpCaseCard.vue?vue&type=script&lang=js"
export * from "./FollowUpCaseCard.vue?vue&type=script&lang=js"
import style0 from "./FollowUpCaseCard.vue?vue&type=style&index=0&id=0acccca1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acccca1",
  null
  
)

export default component.exports